import React from 'react';
import { ZoomIn, ZoomOut, RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';

interface MapControlsProps {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export const MapControls: React.FC<MapControlsProps> = ({ 
  scale, 
  onZoomIn, 
  onZoomOut, 
  onReset 
}) => {
  return (
    <div className="absolute top-4 right-4 z-10 flex flex-col gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onZoomIn}
        disabled={scale >= 5}
        className="w-10 h-10 p-0 bg-background/80 backdrop-blur-sm hover-scale"
        aria-label="Zoom in"
      >
        <ZoomIn className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onZoomOut}
        disabled={scale <= 0.5}
        className="w-10 h-10 p-0 bg-background/80 backdrop-blur-sm hover-scale"
        aria-label="Zoom out"
      >
        <ZoomOut className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onReset}
        className="w-10 h-10 p-0 bg-background/80 backdrop-blur-sm hover-scale"
        aria-label="Reset view"
      >
        <RotateCcw className="h-4 w-4" />
      </Button>
      <div className="text-xs text-muted-foreground bg-background/80 backdrop-blur-sm px-2 py-1 rounded border text-center">
        {Math.round(scale * 100)}%
      </div>
    </div>
  );
};